import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import { getCurrentUser, signOut } from 'aws-amplify/auth';
import { USER_LOADED, USER_LOAD_FAILED } from 'redux/actionTypes/user';
import clearCognitoCookies from 'utils/clearCognitoCookies';
import fetchUserAttributesCached from 'utils/fetchUserAttributesCached';
import signIn from 'utils/signIn';
var MAX_RETRIES = 2;
var baseDelay = 1000;
var fetchAttributesWithRetry = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var currentRetry,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          currentRetry = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;
          _context.prev = 1;
          _context.next = 4;
          return fetchUserAttributesCached();
        case 4:
          return _context.abrupt("return", _context.sent);
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](1);
          if (!(_context.t0.name === 'NotAuthorizedException' || currentRetry === MAX_RETRIES)) {
            _context.next = 11;
            break;
          }
          throw _context.t0;
        case 11:
          _context.next = 13;
          return new Promise(function (resolve) {
            setTimeout(resolve, baseDelay * (currentRetry + 1));
          });
        case 13:
          _context.next = 15;
          return fetchAttributesWithRetry(currentRetry + 1);
        case 15:
          return _context.abrupt("return", _context.sent);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 7]]);
  }));
  return function fetchAttributesWithRetry() {
    return _ref.apply(this, arguments);
  };
}();
var loadUser = function loadUser() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var currentUser, attributes, _currentUser, username, userId;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            clearCognitoCookies();
            _context2.prev = 1;
            _context2.next = 4;
            return getCurrentUser();
          case 4:
            currentUser = _context2.sent;
            _context2.next = 12;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](1);
            console.error(_context2.t0);
            signIn();
            return _context2.abrupt("return");
          case 12:
            _context2.prev = 12;
            _context2.next = 15;
            return fetchAttributesWithRetry();
          case 15:
            attributes = _context2.sent;
            _currentUser = currentUser, username = _currentUser.username, userId = _currentUser.userId;
            dispatch({
              type: USER_LOADED,
              payload: {
                user: {
                  username: username,
                  userId: userId,
                  attributes: attributes
                }
              }
            });
            _context2.next = 28;
            break;
          case 20:
            _context2.prev = 20;
            _context2.t1 = _context2["catch"](12);
            console.error(_context2.t1);

            // The local tokens look valid but Cognito rejects them (e.g. revoked by a global sign-out),
            // so signIn() would refuse to redirect while they are still stored.
            if (!(_context2.t1.name === 'NotAuthorizedException')) {
              _context2.next = 27;
              break;
            }
            _context2.next = 26;
            return signOut();
          case 26:
            return _context2.abrupt("return");
          case 27:
            dispatch({
              type: USER_LOAD_FAILED,
              payload: {
                error: _context2.t1.message
              }
            });
          case 28:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 7], [12, 20]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export default loadUser;